import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { useSpring, animated } from 'react-spring';
import SearchBarContext, { useLockFocus } from './context';
import QueryHint from './result-box-elements/query-hint';
import RecentSearches from './result-box-elements/recent-searches';
import SuggestedSearches from './result-box-elements/suggested-searches';

const lineHeight = 28;
const pad = 20;

const Container = styled(animated.div)`
  cursor: default;
  background-color: #ffffff;
  border-radius: 4px;
  position: relative;
  top: ${props => (props.theme.isMobile ? '-4px' : '-8px')};
  box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.15);
  overflow: hidden;
  line-height: ${lineHeight}px;
`;

const getHeight = (inputFocus, showRecent, rsearch, showSuggestion, suggestions, value) => {
  if (!inputFocus) {
    return 0;
  }
  let lines = 0;
  if (_.get(value, 'length')) {
    lines += 1;
  }
  if (showRecent && rsearch.length) {
    lines += rsearch.length + 1;
  }
  if (showSuggestion && suggestions.length) {
    lines += suggestions.length + 1;
  }
  const height = 2 * pad + lines * lineHeight;
  return height;
};

const getWidth = (exp, w, psm) => (exp ? (w - (psm ? 0 : lineHeight)) : 0);

export default function ResultBox() {
  const {
    state: {
      showRecent, showSuggestion, rsearch, suggestions,
      inputFocus, value, expanded, width, pseudoMobile,
      query, caret,
    },
    dispatch,
  } = React.useContext(SearchBarContext);
  const { h, w, padding } = useSpring({
    h: getHeight(inputFocus, showRecent, rsearch, showSuggestion, suggestions, value),
    w: getWidth(expanded, width, pseudoMobile),
    padding: inputFocus ? `${pad}px` : '0px',
  });

  // eslint-disable-next-line complexity
  React.useEffect(() => {
    const len = rsearch.length + suggestions.length;
    if (len && caret >= 0 && caret < len) {
      let item;
      if (rsearch.length && caret >= 0 && caret < rsearch.length) {
        item = rsearch[caret];
      }
      const icaret = caret - rsearch.length;
      if (suggestions.length && icaret >= 0 && icaret < suggestions.length) {
        item = suggestions[icaret];
      }
      if (item) {
        if (item.type) {
          dispatch({ type: 'setValue', payload: item.suggested_term || item.query });
          dispatch({ type: 'setSuggestedSearchItem', payload: item });
        } else {
          dispatch({ type: 'setValue', payload: item.query });
          dispatch({ type: 'setSuggestedSearchItem', payload: null });
        }
      }
    }
  }, [caret, rsearch, suggestions, dispatch]);

  return (
    <Container
      {...useLockFocus()}
      style={{
        padding,
        height: h.interpolate(v => `${v}px`),
        width: w.interpolate(v => `${v}px`),
      }}
    >
      {!!(expanded && _.get(query, 'length')) && <QueryHint />}
      {!!(showRecent && rsearch.length) && <RecentSearches />}
      {!!(showSuggestion && suggestions.length) && <SuggestedSearches />}
    </Container>
  );
}
